(() => {
  let started = false;
  const events = ['pointerdown', 'keydown', 'pagehide'];
  const start = () => {
    if (started) return;
    started = true;
    events.forEach(event => window.removeEventListener(event, start));
    window.removeEventListener('load', ready);
    ['https://www.googletagmanager.com/gtm.js?id=GTM-NMVR6W8Z',
     'https://bzrcdn.openai.com/sdk/oaiq.min.js',
     'https://www.clarity.ms/tag/obfwoppv0t'].forEach(src => {
      if (Array.from(document.scripts).some(script => script.src === src)) return;
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.head.append(script);
    });
  };
  events.forEach(event => window.addEventListener(event, start, {once: true, passive: true}));
  const ready = () => {
    if (started) return;
    if (document.visibilityState === 'hidden') start();
    else requestAnimationFrame(() => requestAnimationFrame(() => {
      if (started) return;
      if ('requestIdleCallback' in window) window.requestIdleCallback(start, {timeout: 1000});
      else start();
    }));
  };
  if (document.readyState === 'complete') ready();
  else window.addEventListener('load', ready, {once: true});
})();
